import ajax from './index'
import apiEnv from './apiEnv'

// 获取证书库管理列表
export function ListCertificateType(data) {
    return ajax.post(`${apiEnv.api4}/api/AccountCertificate/ListCertificateType`, data)
}
// 添加证书类型
export function AddCertificateType(data) {
    return ajax.post(`${apiEnv.api4}/api/AccountCertificate/AddCertificateType`, data)
} 
// 修改证书类型
export function UpdateCertificateType(data) {
    return ajax.post(`${apiEnv.api4}/api/AccountCertificate/UpdateCertificateType`, data)
} 
// 修改证书状态
export function UpdateCertificateTypeStatus(data) {
    return ajax.post(`${apiEnv.api4}/api/AccountCertificate/UpdateCertificateTypeStatus`, data)
} 
// 修改帧数编号（上移，下移）
export function UpdateCertificateTypeSortNo(data) {
    return ajax.post(`${apiEnv.api4}/api/AccountCertificate/UpdateCertificateTypeSortNo`, data)
} 